export const dfciRasterTileConfigs = {
  urban: {
    id: "urban",
    type: "raster",
    isDynamic: true,
    sourceId: "urban-raster-source",
    layerId: "urban-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/urban/raster/{z}/{x}/{y}.webp`,
      ],
        tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 0.8,
      },
    },
  },
   dem: {
    id: "dem",
    type: "raster",
    isDynamic: true,
    sourceId: "dem-raster-source",
    layerId: "dem-raster-layer",
    source: {
      type: "raster",
      tiles: [
        `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/dem/raster/{z}/{x}/{y}.webp`,
      ],
      tileSize: 256,
      minzoom: 0,
      maxzoom: 22,
    },
    layer: {
      type: "raster",
      paint: {
        "raster-opacity": 1,
      },
    },
    popup: {
      enabled: true,
      endpoint: `${process.env.REACT_APP_MAPPER_DFCI_BASEURL_V1}/dem/raster/point`,
      label: "Elevation",
      unit: "m",
    },
  },
};
